// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__1joTw","modalTitle":"styles_modalTitle__2cFUK","actionButton":"styles_actionButton__wgQAL"};